import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Tracks whether the user has "locked" the sidebar into expanded mode (by
 * clicking a menu item while the layout is in mini mode). The lock is shared
 * between AppSidebar and AppSubmenuPanel so the sidebar only collapses when
 * the mouse leaves *both* surfaces.
 */
@Injectable({ providedIn: 'root' })
export class SidebarLockService {

    private readonly locked$ = new BehaviorSubject<boolean>(false);

    isLocked(): Observable<boolean> {
        return this.locked$.asObservable();
    }

    snapshot(): boolean {
        return this.locked$.value;
    }

    setLocked(value: boolean): void {
        if (this.locked$.value !== value) {
            this.locked$.next(value);
        }
    }
}
